export const handleRecipientDialogCloseAndNavigation = (search, navigate, setIsRecipientDialogOpen) => {
  const searchParams = new URLSearchParams(search);
  let pathname = 'card/customization/address';
  const currentPath = window.location.pathname;

  if (currentPath.includes('card/customization/preview')) {
    pathname = currentPath.replace('card/customization/preview', 'card/customization/address');
    navigate({ pathname, search: searchParams.toString() });
  } else {
    setIsRecipientDialogOpen(false);
  }
};
